import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 19v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z","key":"svg-0"}],["path",{"d":"M11 17h2","key":"svg-1"}],["path",{"d":"M9 14h6","key":"svg-2"}],["path",{"d":"M10 11h4","key":"svg-3"}]]

const IconAlignBoxCenterBottom = createReactComponent('outline', 'align-box-center-bottom', 'AlignBoxCenterBottom', __iconNode);

export default IconAlignBoxCenterBottom;